import React from "react";
import "../styles/CarSpinner.css";

function CarSpinner() {
  return <div class="loader quantum-spinner"></div>;
}

export default CarSpinner;
